module.exports = __webpack_public_path__ + "static/media/feedback_and_reviews_big.b466468e.png";